import ProfileSettings from "./ProfileSettings.container";
export default ProfileSettings;